export const BuildInfo = {
    isDev: process.env.NODE_ENV === "development" || location.origin.includes(process.env.IsDevOrigin as string),
    isBasicCompany: location.origin.includes(process.env.IsBasicCompanyOrigin as string),
    subscriptionKey: process.env.SubscriptionKey as string,
}
